import React from "react";

import { FiArrowLeft } from "react-icons/fi";

import { Button } from "newui/components/Button";
import { useSwitchCompany } from "../../hooks/useSwitchCompany";
import { useExecutiveView } from "../../hooks/useExecutiveView";

export const BackToProcuraconButton: React.FC = () => {
	const { isActive } = useExecutiveView();
	const { switchBack, isLoading } = useSwitchCompany();

	if (!isActive) {
		return null;
	}

	return (
		<Button
			btntype="primary"
			onClick={switchBack}
			isLoading={isLoading}
			className="mb-4 flex w-full items-center justify-center gap-2"
			data-testid="back-to-procuracon-btn"
		>
			<FiArrowLeft size={16} />
			Back to Procuracon
		</Button>
	);
};
